import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ab3a010c976fe91adc28234a9deb4afcbb from "./generated-75802184-0c37-4852-afe5-f7917b07e2a2.json";

import a16236cff22fcc8995e95fd08faa38be6b from "./generated-153b7a40-7355-4988-a040-28fe07e5bb35.json";

import a9035c8b19d4e58a509a3fcadcd9d28f4b from "./generated-7eab1879-73cb-4e34-8a0a-f39374bf481d.json";

import a268721c352872b83977b95633ce85dd3b from "./generated-3c02b1a0-4915-4256-a959-b5804ea249aa.json";

import adeace45417d9571f374c03d949e67083b from "./generated-8d68e3b7-06e6-45ad-814d-acdb9ea6f2e6.json";

import a6fd95b6cc67e2c326121037b3dfa4022b from "./generated-5dfabe89-cc88-4dbb-bf18-bec3b58fafe9.json";

import afdcce2692e40755bd8c2fd9f23981421b from "./generated-7534dad7-6684-4b37-b49d-7a67a06fae46.json";

import a683d7bf7f1d9c8c739a2bbae28a0f0d6b from "./generated-3aec5f34-ec3e-444a-8ef7-500102de05d7.json";

import a72cd262cc86c74bf0aac3667eca5d211b from "./generated-58770be0-97db-4542-93d1-aed009bdfec4.json";

import a62f71f2e58b98948c687efbd649029d2b from "./generated-7ca2d0ff-b3c1-4a27-8d96-2071d473be98.json";

import a6a32cb8b4c532e957c4a662db7a1c1c2b from "./generated-4c8c6072-98b7-4c18-8a20-627dc42821af.json";

import a08f86d24135b317415a7f6e8de801834b from "./generated-ad6c6454-284f-459d-b036-9fba7225e70c.json";

import a8ac1cd028482b1d04961c122922ee569b from "./generated-ffb1b6e4-59aa-4bb8-82d5-cada45d6504d.json";

import a73b282a278b2099cdf1241377b231230b from "./generated-3bd2f3da-e4df-4d38-8670-94c4b3302cc3.json";

import a70a980ecad5d9861930a0ba643072ac8b from "./generated-5221eddf-a4de-4a4d-be27-6bb4ce7cf764.json";

import a33974f6b688454f0d3af666997bee516b from "./generated-2cd94439-015a-4324-916f-fb420b076f98.json";

import a57dfd60a93b110376b6a3a8564f621cab from "./generated-02bbf7b4-b7d3-4fa3-9978-d89f32a43a29.json";

import a9558ccb5905283d0ffbcb998784063a3b from "./generated-e3fb723f-508d-46c5-9bd6-632805ba187e.json";

import a9a3f3a1af04216ffb34f2caedb9f167db from "./generated-040f1ffe-2f6d-489c-8b0a-c1b53c6aadc6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ab3a010c976fe91adc28234a9deb4afcbb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a16236cff22fcc8995e95fd08faa38be6b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9035c8b19d4e58a509a3fcadcd9d28f4b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a268721c352872b83977b95633ce85dd3b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(adeace45417d9571f374c03d949e67083b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a6fd95b6cc67e2c326121037b3dfa4022b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(afdcce2692e40755bd8c2fd9f23981421b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a683d7bf7f1d9c8c739a2bbae28a0f0d6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a72cd262cc86c74bf0aac3667eca5d211b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a62f71f2e58b98948c687efbd649029d2b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6a32cb8b4c532e957c4a662db7a1c1c2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a08f86d24135b317415a7f6e8de801834b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a8ac1cd028482b1d04961c122922ee569b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a73b282a278b2099cdf1241377b231230b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a70a980ecad5d9861930a0ba643072ac8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a33974f6b688454f0d3af666997bee516b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a57dfd60a93b110376b6a3a8564f621cab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9558ccb5905283d0ffbcb998784063a3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a9a3f3a1af04216ffb34f2caedb9f167db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a57dfd60a93b110376b6a3a8564f621cab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */